import { CLEAR_UNITS, SEARCH_UNITS_SUCCESS } from '../actionConstants';

const defaultState = {
  units: [],
};

export default (state = defaultState, action) => {
  const { type, res } = action;
  switch (type) {
    case SEARCH_UNITS_SUCCESS:
      return {
        ...state,
        units: res?.data ?? [],
      };
    case CLEAR_UNITS:
      return {
        ...state,
        units: [],
      };
    default:
      return state;
  }
};
